
import React, {useEffect} from "react";
import { ThemeProvider } from "@material-tailwind/react";

import { SharedProvider } from "./hooks/useShared";
import routes from "./routes/ARoutes";
import { setDefaultLanguage, setDefaultTranslations } from 'react-multi-lang'
import en from './assets/locales/en.json'
import dr from './assets/locales/dr.json'
import useNetwork from './hooks/useNetwork'
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
setDefaultTranslations({ dr, en })
setDefaultLanguage( (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')?'en':'dr')

function App() {
  const toastId = React.useRef(null);
  const location = useLocation();
  const isOnline =  useNetwork()

  useEffect(() => {
    if(!isOnline){
      if(! toast.isActive(toastId.current)) {
        toastId.current =toast.warning("You don't have internet connection!", {theme: "dark",position: "top-center",})
      }
    }
      
  }, [isOnline,location])


 
  return (
    <ThemeProvider>
   
        <SharedProvider>
        
            {routes}
         <ToastContainer/>
        </SharedProvider>
   
    </ThemeProvider>
  );
}

export default App;
